import { OperationType, ROUTE_PATH } from 'common/constants/sm-constants';
import {
  GridMetaModel,
  Headers,
} from 'common/models/utility-models/meta-model';
import { InternshipFilterMetaModel } from '../Intership Filter Form/internship-list-filter-meta.model';
import { MetaModel } from 'common/models/utility-models/base-model';

export class InternshipDetailsGridMetaModel extends GridMetaModel<Headers> {
  filterMeta = new InternshipFilterMetaModel().getMetaModel();

  constructor() {
    super(
      'Internship Students',
      ROUTE_PATH.intershipDetails,
      ROUTE_PATH.internship,
      false,
      false,
      8,
      true,
      true,
      ['orgname', 'orgemail', 'internshipTitle', 'companyName', 'locName'],
      false,
      [],
      {
        isDownloadExcel: true,
        excelFileName:
          'Intership List ' + new Date().toLocaleDateString() + '.xlsx',
        btnLabel: 'Download List',
        headers: [
          { key: 'Full_Name', value: 'name' },
          { key: 'E_Mail', value: 'email' },
          { key: 'Contact', value: 'mobile_number' },
          { key: 'State', value: 'stateName' },
          { key: 'Joining_Date', value: 'studentJoinDateByMentor' },
          { key: 'End_Date', value: 'studentCompletedDateByMentor' },
          { key: 'Student_Status', value: 'studentStatus' },
          { key: 'Certificate', value: 'isInternshipCertyVerified' },
          { key: 'Mentor_Status', value: 'internshipStatusByMentor' },
          { key: 'Gender', value: 'gender' },
          { key: 'College_Name', value: 'name_of_college' },
          { key: 'Branch', value: 'department_name' },
          { key: 'Batch', value: 'batch_number' },
          { key: 'Region', value: 'zone_name' },
          { key: 'First_Semester', value: 'first_year_score' },
          { key: 'Second_Semester', value: 'second_year_score' },
          { key: 'Third_Semester', value: 'third_year_score' },
          { key: 'Fourth_Semester', value: 'fourth_year_score' },
          { key: 'Fifth_Semester', value: 'fifth_year_score' },
          { key: 'Sixth_Semester', value: 'first_year2_score' },
          { key: 'Seventh_Semester', value: 'second_year2_score' },
          { key: 'Eight_Semester', value: 'third_year2_score' },
          { key: 'Nineth_Semester', value: 'fourth_year2_score' },
          { key: 'Tenth_Semester', value: 'fifth_year2_score' },
        ],
      },
      false,
      null,
      false,
      true,
      null,
      null,
      null,
      null,
      null,
      {
        isPreview: false,
        isPreviewType: '',
        isEnvUrl: false,
        linkKey: ['filePath'],
        previewName: '',
      },
      {
        isTabSwitch: false,
        label: '',
        isChecked: false,
      },
      false,
      true,
      true,
      [],
      false,
      {
        isExtraActions: true,
        btnLabel: 'Ask Mentor for feedback',
        selectOptions: [],
        selectedValue: '',
        isPreviewBtn: false,
        previewBtnLabel: 'Upload Status',
      },
      {
        isCheckboxEmit: true,
        emitKey: 'id',
        checkedKey: '',
        valueKey: '',
      },
      {
        isDownload: false,
        key: '',
        valueKey: '',
      },
      {
        isTabStatus: false,
        label: '',
        isChecked: false,
      },
      false,
      false,
      {
        isPrimary: true,
        isDanger: false,
      },
      '',
      { value: '', isVisible: false },
      false,
      false,
      true,
      {
        isExtraActions: true,
        btnLabel: 'Import List',
        selectOptions: [],
        selectedValue: '',
        isPreviewBtn: true,
        previewBtnLabel: 'Import List',
      },
      { value: '', isVisible: false },
      true
    );
  }

  prepareHeaderList(): Headers[] {
    const headers: Headers[] = [];
    const orgname = new Headers(
      'Full Name',
      'name',
      true,
      true,
      'text',
      '0'
    );
    const isStudentContinued = new Headers(
      'Status from Student',
      'studentStatus',
      false,
      true,
      'textUrl'
    );
    const isInternshipCertyVerified = new Headers(
      'Certificate ',
      'isInternshipCertyVerified',
      true,
      true,
      'isInternshipCertyVerified'
    );
    const internshipStatusByMentor = new Headers(
      'Status from Mentor ',
      'internshipStatusByMentor',
      true,
      true,
      'text'
    );
    // const internshipMasterId = new Headers('', 'internshipMasterId', false, false, "");
    const preview = new Headers(
      '',
      'preview',
      false,
      true,
      'redirect',
      '0',
      {
        isColumnNavigation: true,
        navigationUrl: ROUTE_PATH.studentInternshipAvailabilityDetails,
        navigateOperationType: OperationType.UPDATE,
        navigateTransferData: {},
      },
      null,
      {
        isToggle: false,
        toggleKey: '',
        toggleCheckedValue: '',
        toggleUncheckedValue: '',
      },
      true
    );

    headers.push(orgname);
    headers.push(isStudentContinued);
    headers.push(isInternshipCertyVerified);
    headers.push(internshipStatusByMentor);
    // headers.push(internshipMasterId);

    headers.push(preview);
    return headers;
  }

  override getMetaModel(): MetaModel {
    const pageData = new MetaModel();
    pageData.pageTitle = this.pageTitle;
    pageData.properties = this.initProperties();
    pageData.redirectPath = this.redirectPath;
    pageData['filterMeta'] = this.filterMeta;
    return pageData;
  }
}
